import { Component, Input, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-invoice-item',
  templateUrl: './invoice-item.component.html',
  styleUrls: ['./invoice-item.component.scss']
})
export class InvoiceItemComponent implements OnInit {
  @Input() invoice: any;

  constructor() { }

  ngOnInit(): void {
  }

  get classItem(): string {
    return `flex flex-col gap-1 p-3 rounded text-sm bg-${ this.invoiceStatus.color }-50
    border-4 border-${ this.invoiceStatus.color }-200 `;
  }

  get invoiceStatus() {
    switch (this.invoice.status) {
      case 'payed':
        return {
          'name': 'PAGO',
          'color': 'green'
        }
      case 'negative':
        return {
          'name': 'NEGATIVADO',
          'color': 'orange'
        }
      case 'protest':
        return {
          'name': 'PROTESTO',
          'color': 'orange'
        }
      case 'agreement':
        return {
          'name': 'ACORDO',
          'color': 'black'
        }
      case 'parcial':
        return {
          'name': 'PARCIAL',
          'color': 'purple'
        }
      case 'today':
        return {
          'name': 'HOJE',
          'color': 'blue'
        }
      case 'overdue':
        return {
          'name': 'VENCIDO',
          'color': 'red'
        }
      default:
        return {
          'name': 'ABERTO',
          'color': 'gray'
        }
    }
  }

  public openSell() {
    window.open(
      `${ environment.apiUrl }/report/sell?code=${ this.invoice.sell.id }`,
      '_blank'
    );
  }

  public openBill() {
    window.open(
      `${ environment.apiUrl }/report/ticket?code=${ this.invoice.id }`,
      '_blank'
    );
  }
}
